<template>
    <list-f
        @childMousedown="handleChoose"
        :list="data"
        :look="list.look"
    />
</template>

<script>
import { mapState } from 'vuex';
import ListF from '@/code-lab/view/organization/custom/list-f.vue';
const Cookies = window.Cookies;
const cookieDomain = process.env.VUE_APP_cookie_domain;
export default {
    components: { ListF },
    data () {
        return {
            data: [
                { label: "简体中文", title: this.$t("code-lab/component/layout/languageSelect.vue_1"), langCode: 'zh-CN', language: 'zh', active$: '', },//  disabled$: 'cursor:n!; hover:bgc:transparent!; opacity:0.6;!' 
                { label: "繁體中文", title: this.$t("code-lab/component/layout/languageSelect.vue_3"), langCode: 'zh-TW', language: 'tw', active$: '' },
                { label: "English", title: 'Language selection', langCode: 'en-US', language: 'en', active$: '',  }, // disabled$: 'cursor:n!; hover:bgc:transparent!; opacity:0.6!;'
                { label: "日本語", title: '言語を選択してください', langCode: 'ja-JP', language: 'jp', active$: '',  }, // disabled$: 'cursor:n!; hover:bgc:transparent!; opacity:0.6!;'
                { label: "한국어", title: '언어를 선택하세요', langCode: 'ko-KR', language: 'ko', active$: '',  },
            ],
            isShow: false,
            text: { title: '', label: '' },
            list: {
                look: {
                    item: `h:30px; lh:30px; text-a:l; font-w:300; pl:15px; hover:bgc:#000000; c:#ffffff;`,
                    wrapper: `w:100%; bgc:#333333; pt:8px; pb:5px; radius:4px;`
                }
            },
            langCode: null
        }
    },
    watch: {
        workSpace(value){
            if(value){
                this.$nextTick(() => {
                    this.readLocalToWorkspace();
                })
            }
        }
    },
    computed: {
        ...mapState(['workSpace', 'projectData']),
        script () {
            return this.projectData.script
        }
    },
    created(){
        let langCode = Cookies.get("langCode");
        let langItem = this.data.find(item => item.langCode === langCode);
        if(!langItem){
            langCode = "zh-TW";
            let language = "tw";
            Cookies.set('langCode', langCode, { domain: cookieDomain, expires: 1 })
            Cookies.set('language', language, { domain: cookieDomain, expires: 1 })
            langItem = this.data.find(item => item.langCode === langCode);
        }
        this.langCode = langCode;
        this.text = {title: langItem.title, label: langItem.label};
        this.$emit('transformMsg', { ...this.text });
        this.$store.commit("SET_LANG_CODE", langCode)
    },
    methods: {
        readLocalToWorkspace () {
            const localWorkSpaceData = window.localStorage.getItem('workSpaceData$')
            if (!/^\<xml/.test(localWorkSpaceData)) return
            const xml = window.Blockly.Xml.textToDom(localWorkSpaceData)
            window.Blockly.Xml.hardDomToWorkspace(xml, this.workSpace)
            window.localStorage.removeItem('workSpaceData$')
        },
        handleChoose ({ item }) {
            const {langCode, language} = item;
            if(langCode === this.langCode){
                return;
            }
            Cookies.set('langCode', langCode, { domain: cookieDomain, expires: 1 })
            Cookies.set('language', language, { domain: cookieDomain, expires: 1 })
            window.localStorage.setItem('workSpaceData$', this.script)
            window.location.reload()
        }
    },
}
</script>
